// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs_breadcrumbs__jK1rk","list":"breadcrumbs_list__WNHIQ","item":"breadcrumbs_item__NAr0t","separator":"breadcrumbs_separator__phz1y"};